import { isStudents, isUnsupportedPage } from 'utils/checkUrl';
import isSupportedBrowser from 'utils/isSupportedBrowser';
// [元コード]: import { isAndroid, isIos, isWebview } from 'utils/isWebView'
// ※Androidブラウザ利用許可に伴い、isAndroid判定をコメントアウトしたため未使用エラー回避で除外
import { isIos, isWebview } from 'utils/isWebView';
import { isPc } from 'utils/userAgent';
const allowPathList = [
    '/',
    '/teachers',
    '/teachers/signin',
    '/teachers/signup',
    '/students',
    '/students/signin',
    '/students/signup',
    '/students/signin/profile/edit/info', // SNS登録
    '/students/profile/edit/info', // SNS登録
];
const allowIncludePath = 'password_renew';
export default () => {
    if (isWebview()) {
        return false;
    }
    if (allowPathList.includes(window.location.pathname)) {
        return false;
    }
    if (window.location.pathname.search(allowIncludePath) !== -1) {
        return false;
    }
    if (isPc() && isSupportedBrowser() && isUnsupportedPage()) {
        window.location.href = '/';
        return true;
    }
    if (isWebview() === false && isIos()) {
        window.alert('Sailへの登録ありがとうございました！続きはアプリで会話をお楽しみください。');
        window.location.href =
            'https://itunes.apple.com/jp/app/sail-japanese-conversations/id1434041945';
        return true;
    }
    // Androidスマートフォンのブラウザからの利用を許可するため、Google Playへのリダイレクトを解除
    // if (isWebview() === false && isAndroid()) {
    //   window.alert('Sailへの登録ありがとうございました！続きはアプリで会話をお楽しみください。')
    //   window.location.href = 'https://play.google.com/store/apps/details?id=jp.helte.android.sail'
    //   return true
    // }
    if (isPc() && !isSupportedBrowser() && isUnsupportedPage() === false) {
        window.location.href = isStudents() ? '/students/unsupported' : '/teachers/unsupported';
        return true;
    }
    return false;
};
